import axios from 'axios'
import http from "../http-common"

const AUTH_URL = `${process.env.VUE_APP_BASE_URL}/auth/`

class AuthService {
  login(user) {
    return axios
      .post(AUTH_URL + 'signin', {
        username: user.username,
        password: user.password
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data))
        }
        return response.data
      })
  }

  logout() {
    localStorage.removeItem('user')
  }

  register(user) {
    return axios.post(AUTH_URL + 'signup', {
      username: user.username,
      password: user.password,
      email: user.email,
      fullName: user.fullName,
      phone: user.phone,
      metric: user.metric,
      timezone: user.timezone,
      customerID: user.customerID,
      roles: user.roles
    })
  }

  migrate(user) {
    return axios.post(AUTH_URL + 'migrate', {
      username: user.username,
      password: user.password,
      email: user.email,
      fullName: user.fullName,
      phone: user.phone,
      metric: user.metric,
      timezone: user.timezone,
      customerID: user.customerID,
      roles: user.roles
    })
  }

  checkTech(user) {
    return axios
      .post(AUTH_URL + 'check', {
        username: user.username,
        password: user.password
      })
      .then(response => {
        // if (response.data.accessToken) {
        //   localStorage.setItem('user', JSON.stringify(response.data))
        // }
        return response.data
      })
  }

  getAll() {
    return http.get("/auth/users")
  }

  getCustomerUsers(customerID) {
    return http.get(`/auth/users?customerid=${customerID}`)
  }

  get(userID) {
    return http.get(`/auth/users/${userID}`)
  }

  // create(data) {
  //   return http.post("/auth/users", data)
  // }

  update(userID, data) {
    return http.put(`/auth/users/${userID}`, data)
  }

  delete(userID) {
    return http.delete(`/auth/users/${userID}`)
  }

  deleteAll() {
    return http.delete(`/auth/users`)
  }

  findByUsername(username) {
    return http.get(`/auth/users?username=${username}`)
  }

  findByUsernameLimited(username) {
    return http.get(`/auth/users?username=${username}&limited=true`)
  }

  findByEmailLimited(email) {
    return http.get(`/auth/users?email=${email}&limited=true`)
  }
}

export default new AuthService();